import React, {useEffect, useState} from 'react'
import {KTSVG} from 'helpers'

export interface ITab {
 title: string
 id: string
 icon?: string
 count?: number
 value?: number
}

type Props = {
 activeTabId: string
 containerClass?: string
 tabHeaderContainerClass?: string
 tabHeaderClass?: string
 className?: string
 iconClass?: string
 activeClass?: string
 tabBodyClass?: string
 tabContent?: React.ReactNode
 tabs?: Array<ITab>
 disableHash?: boolean
 controlledTab?: boolean
 onClick: (value: string) => void
}

const KTTab: React.FC<Props> = ({
 containerClass,
 tabHeaderContainerClass,
 tabHeaderClass,
 activeClass,
 iconClass,
 tabBodyClass,
 onClick,
 tabs,
 disableHash = false,
 controlledTab = false,
 activeTabId,
 tabContent,
}) => {
 const [activeTab, setActiveTab] = useState('')
 const selectedTabId = controlledTab
  ? activeTabId
  : activeTab

 const handleTabClick = (
  tabId: string,
  callOnClickFunction = true
 ) => {
  if (!disableHash) {
   window.location.hash = `#${tabId}`
  }
  if (!controlledTab) {
   setActiveTab(tabId)
  }
  if (callOnClickFunction) onClick(tabId)
 }

 useEffect(() => {
  if (controlledTab) return
  if (!tabs || tabs.length === 0) return
  if (activeTab !== '') return

  const hash = window.location.hash
  if (hash && !disableHash) {
   handleTabClick(hash.substring(1))
  } else {
   handleTabClick(tabs[0].id, true)
  }
 }, [tabs])

 return (
  <div className={`${containerClass}`}>
   <div
    className={`${tabHeaderContainerClass} flex justify-center text-base font-medium border-[#E6EBF0] border-b`}
   >
    {tabs?.map((val: ITab, key: number) => (
     <div
      key={key}
      className={`${tabHeaderClass} ${
       selectedTabId === val.id && activeClass
      } flex mx-2 pb-2 cursor-pointer`}
      onClick={() => {
       handleTabClick(val.id)
      }}
     >
      <span>
       {val.title}
       {val.count !== undefined && (
        <span className={`${iconClass} ml-1`}>
         ({val.count})
        </span>
       )}
      </span>

      {val.icon && (
       <KTSVG
        className={`${iconClass} w-6 h-6 ml-1`}
        path={val.icon}
       />
      )}
     </div>
    ))}
   </div>
   <div
    className={`${tabBodyClass} text-base font-medium py-2`}
   >
    {tabContent}
   </div>
  </div>
 )
}

export {KTTab}
